document.addEventListener('DOMContentLoaded', () => {
    function toggleBlogSlider() {
        const screenWidth = $(window).width();
        if (screenWidth <= 991) {
            if ($(".container-block-resources__articulos").length > 0 && !$(".container-block-resources__articulos").hasClass("slick-initialized")) {
                $(".container-block-resources__articulos").slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                    infinite: false,
                    arrows: false,
                    autoplay: true,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1.15
                            }
                        }
                    ]
                });
            }
        } else {
            if ($(".container-block-resources__articulos").length > 0 && $(".container-block-resources__articulos").hasClass("slick-initialized")) {
                $(".container-block-resources__articulos").slick("unslick");
            }
        }
    }
    toggleBlogSlider();
    $(window).resize(function () {
        setTimeout(function () {
            toggleBlogSlider();
        }, 300);
    });
})